import React from 'react';
import { ContentTemplate, TitleHeader } from 'web-library';
import { useTranslation } from 'react-i18next';
import TwoFactorAuthenticationSetting from '../../modules/profile/components/TwoFactorAuthenticationSetting';

const Settings = () => {
  const { t } = useTranslation();
  return (
    <>
      <TitleHeader title={t('profile->>TwoFactorAuthenticationSetting.Settings')} />

      <ContentTemplate>
        <TwoFactorAuthenticationSetting />
      </ContentTemplate>
    </>
  );
};

export default Settings;
